/**
 * ArthKundliPro Component
 * Embeds the Arth Gurukul Pro application within the dashboard
 */
import React, { useState } from 'react';
import { FaChartLine, FaSpinner, FaExpand, FaCompress } from 'react-icons/fa';

const ARTH_KUNDLI_PRO_URL = 'https://arth-kundli-pro-716380887300.us-west1.run.app/';

const ArthKundliPro = () => {
  const [loading, setLoading] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  return (
    <div className={`${isFullscreen ? 'fixed inset-0 z-50 bg-[#0A1929]' : 'space-y-4'}`}>
      {/* Header */}
      <div className={`bg-gradient-to-r from-[#1A2942] to-[#1E3A5F] ${isFullscreen ? 'p-4' : 'rounded-xl p-6'} border-b border-[#2D5A8F]`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#FFD700] to-[#FFA500] flex items-center justify-center">
              <FaChartLine size={20} className="text-[#0A1929]" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-white">Arth Gurukul Pro</h2>
              <p className="text-gray-400">Comprehensive Financial Planning Tool</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={toggleFullscreen}
              className="p-2 bg-[#2D5A8F] text-white rounded-lg hover:bg-[#3D6A9F] transition-all"
              title={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
            >
              {isFullscreen ? <FaCompress size={18} /> : <FaExpand size={18} />}
            </button>
          </div>
        </div>
      </div>

      {/* Embedded Content */}
      <div className={`relative ${isFullscreen ? 'h-[calc(100vh-88px)]' : 'h-[calc(100vh-220px)] min-h-[600px]'} bg-[#0F172A] ${isFullscreen ? '' : 'rounded-xl'} border border-[#2D5A8F] overflow-hidden`}>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-[#0A1929] z-10">
            <div className="text-center">
              <FaSpinner className="animate-spin text-[#FFD700] text-4xl mx-auto mb-4" />
              <p className="text-gray-400">Loading Arth Gurukul Pro...</p>
            </div>
          </div>
        )}
        <iframe
          src={ARTH_KUNDLI_PRO_URL}
          title="Arth Gurukul Pro"
          className="w-full h-full border-0"
          onLoad={handleIframeLoad}
          allow="fullscreen"
          data-testid="arth-kundli-pro-iframe"
        />
      </div>

      {/* Footer Note */}
      {!isFullscreen && (
        <div className="text-center text-gray-500 text-sm">
          <p>Arth Gurukul Pro is a comprehensive financial planning tool powered by MDRT School</p>
        </div>
      )}
    </div>
  );
};

export default ArthKundliPro;
